// angular import
import { Component } from '@angular/core';

// project import
import { LayoutService } from 'src/app/@theme/services/layout.service';
import { faBars, faCoffee, faHamburger } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-nav-left',
  templateUrl: './toolbar-left.component.html',
  styleUrls: ['./toolbar-left.component.scss']
})
export class NavLeftComponent {
  
  faMenu=faBars
  // constructor
  constructor(private layoutService: LayoutService) {}

  // public method
  toggleMenu() {
    this.layoutService.toggleSideDrawer();
  }
}
